import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/tailwind.css'
import vueSmoothScroll from 'vue-smooth-scroll'
// import './assets/test.js'

Vue.use(vueSmoothScroll)
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
